import * as _ from 'lodash';
import { useReducer } from 'react';

const accordionTableReducer = (
  state: number[],
  action: { isExpanded: boolean; index: number },
) => {
  const { isExpanded, index } = action;
  // expanded + exists in state, remove it
  if (isExpanded && _.includes(state, index)) {
    return _.filter(state, (currentIndex) => currentIndex !== index);
  }
  // closed + not in state, add it
  if (!isExpanded && !_.includes(state, index)) {
    return [...state, index];
  }
  return state;
};

export const useAccordionTableReducer = (initialState: number[] = []) => {
  const [openedAccordionIndices, setOpenedAccordionIndices] = useReducer(
    accordionTableReducer,
    initialState,
  );

  return { openedAccordionIndices, setOpenedAccordionIndices };
};
